import React from "react";

// البطاقة الأساسية
function Card({ children, className }) {
  return (
    <div
      className={`bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl shadow-sm p-4 ${className}`}
    >
      {children}
    </div>
  );
}

// رأس البطاقة
function CardHeader({ children, className }) {
  return (
    <div
      className={`border-b border-gray-200 dark:border-gray-700 pb-2 mb-2 ${className}`}
    >
      {children}
    </div>
  );
}

// محتوى البطاقة
function CardContent({ children, className }) {
  return <div className={`p-2 ${className}`}>{children}</div>;
}

// عنوان البطاقة
function CardTitle({ children, className }) {
  return <h3 className={`text-lg font-bold ${className}`}>{children}</h3>;
}

// التصدير
export { Card, CardHeader, CardContent, CardTitle };